import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicVariationParameters = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="METHOD OF VARIATION OF PARAMETERS"
      videos={[
        "https://www.youtube.com/embed/lZTJIjfxMrA",
        "https://www.youtube.com/embed/TuJnE6ooO0U",
      ]}
      takeaways={[
        { text: "Practice as many problems as you can" },
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicVariationParameters;